// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nt-0";
export var animationContainer = "_nt-1";
export var itemPrice = "_nt-a";
export var itemizedContent = "_nt-9";
export var itemizedHeader = "_nt-7";
export var itemizedRow = "_nt-8";
export var itemizedSection = "_nt-6";
export var modalContent = "_nt-2";
export var orderName = "_nt-3";
export var refundOption = "_nt-4";
export var refundOptionsContainer = "_nt-5";
export var shippingLabel = "_nt-b";
export var totalRow = "_nt-c";